import { Box, useTheme } from "@mui/material";

import NavBackButton from "../../../components/NavBackButton";
import NotifSingleButton from "../../../components/NotifSingleButton";
import { useAppSelector } from "../../../../hooks/useRedux";
interface Props {
  hasScroll?: boolean;
  title: JSX.Element;
}

export default function MobileHeader({ title }: Props) {
  const hasScroll = useAppSelector((state) => state.settings.hasScroll);

  const theme = useTheme();
  return (
    <Box
      sx={{
        position: "fixed",
        maxWidth: "450px",
        height: "60px",
        top: "0px",
        width: "100%",
        zIndex: 150,
        backgroundColor: theme.palette.bgColor.grey100,
        transition: "box-shadow 1000ms",
        boxShadow: hasScroll ? "0px 4px 8px 3px rgba(0,0,0,0.1)" : "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingY: "0px",
        paddingX: "8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <NavBackButton />
        {title}
      </Box>

      <NotifSingleButton path="/driver/notifications" />
    </Box>
  );
}
